import { cloneDeep, merge } from 'lodash-es';
import { CHART_TYPES } from '../enums';
import { getVar } from './builder-helpers';

const font = { family: '"Poppins"' };

export default (config, chartConfig) => {
  const DEFAULT_OPTIONS_HORIZONTAL = {
    font,
    indexAxis: 'y',
    resizeDelay: 10,
    maintainAspectRatio: false,
    responsive: true,
    interaction: {
      mode: 'nearest',
      intersect: true
    },
    plugins: {
      datalabels: {
        display: false
      },
      tooltip: {
        usePointStyle: false,
        enabled: false,
      },
      autocolors: false,
    },
    scales: {
      y: {
        display: false,
        grid: {
          color: 'transparent',
          borderColor: '#B5BECC',
        }
      },
      x: {
        adapters: {
          date: 'chartjs-adapter-moment'
        },
        beginAtZero: false,
        grid: {
          borderDash: [2, 1],
          color: '#DADEE4',
          borderColor: 'transparent',
          borderWidth: 1,
          drawTicks: false,
          tickColor: '#B5BECC',
          lineWidth: 1,
          tickLength: 6
        },
        ticks: {
          color: '#8696AC',
          maxRotation: 0,
          font
        }
      }
    }
  };

  const DEFAULT_OPTIONS = {
    font,
    resizeDelay: 10,
    maintainAspectRatio: false,
    responsive: true,
    interaction: {
      mode: 'nearest',
      intersect: false
    },
    plugins: {
      datalabels: false,
      tooltip: {
        usePointStyle: false,
        enabled: false,
      },
      autocolors: false,
    },
    scales: {
      y: {
        type: 'linear',
        grid: {
          borderDash: [2, 1],
          borderColor: 'transparent',
          color: getVar('--fc-color-gray-300'),
          lineColor: '#DADEE4',
          drawTicks: true,
          tickColor: 'transparent',
          tickLength: 10
        },
        ticks: {
          color: getVar('--fc-color-gray-700'),
          padding: 0,
          font
        },
        border: false,
        align: 'start'
      },
      x: {
        adapters: {
          date: 'chartjs-adapter-moment'
        },
        beginAtZero: true,
        grid: {
          color: 'transparent',
          borderColor: getVar('--fc-color-gray-500'),
          borderWidth: 1,
          drawTicks: true,
          tickColor: getVar('--fc-color-gray-500'),
          lineWidth: 1,
          tickLength: 6
        },
        ticks: {
          color: getVar('--fc-color-gray-700'),
          maxRotation: 0,
          font
        }
      }
    }
  };
  if (config.series[0].seriesType !== CHART_TYPES.HORIZONTAL_BAR) {
    merge(chartConfig, { options: cloneDeep(DEFAULT_OPTIONS) });

    if (config?.axis) {
      config.axis.reduce((scales, { id, min, max, stacked }) => {
        if (!scales[id]) return scales;
        if (min || min === 0) scales[id].min = min;
        if (max || max === 0) scales[id].max = max;
        if (stacked !== null) scales[id].stacked = stacked;
        return scales;
      }, chartConfig.options.scales);
    }
    return chartConfig;
  }

  return merge(chartConfig, { options: cloneDeep(DEFAULT_OPTIONS_HORIZONTAL) });
};
